/** @format */

import React, { useCallback, useEffect, useState } from "react";
import TextFieldsIcon from "@mui/icons-material/TextFields";
// import WidthNormalIcon from "@mui/icons-material/WidthNormal";
// import HeightIcon from "@mui/icons-material/Height";
// import MultipleStopIcon from "@mui/icons-material/MultipleStop";
import FormatItalicIcon from "@mui/icons-material/FormatItalic";
import FormatBoldIcon from "@mui/icons-material/FormatBold";
import FontDownloadIcon from "@mui/icons-material/FontDownload";
import PanToolIcon from "@mui/icons-material/PanTool";
import FontSizeHover from "../../Pdf-Utils/Tools/FontSizeHover";
import DeleteIcon from "@mui/icons-material/Delete";
import FontSpacingHover from "../FontSpacingHover";
import ColorLensIcon from "@mui/icons-material/ColorLens";
import Tooltip from "@mui/material/Tooltip";
import BoxHeight from "../BoxHeight";
import BoxWidth from "../BoxWidth";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteCoordinate,
  updateCoordinate,
} from "../../../../store/reducers/pdfeditor/pdfCoordinatesSlice";
import FontFamilyBox from "../FontFamilyBox";
import { handleDragToggleButton } from "../../../../store/reducers/pdfeditor/toolsModificationSlice";
import { MuiColorInput } from "mui-color-input";
import { debounce } from "lodash";
import { modifiedCoordinateFunc } from "../../../../store/reducers/pdfeditor/pdfAddedRemovedCoordSlice";

function ToolBarText({
  settedFontSize,
  settedBoxHeight,
  settedBoxWidth,
  position,
  coordinate,
  setSelectedBoxId,
}) {
  const dispatch = useDispatch();
  const { currVariable, dragToggleButton } = useSelector(
    (state) => state.toolsModification
  );
  const { coordinates } = useSelector((state) => state?.pdfCoordinates);
  useState(() => {
    console.log("currvariable in toolbartext", currVariable);
  }, [currVariable]);
  const [showHideBox, setShowHideBox] = useState({
    fontSizeBox: false,
    fontSpaceBox: false,
    boxHeightBox: false,
    boxWidthBox: false,
    fontFamily: false,
    color: false,
  });
  const [enableDraggingText, setEnableDraggingText] = useState(false);
  const [textColor, setTextColor] = useState("#000000");

  const toggleBox = (boxName) => {
    setShowHideBox((prevState) => {
      const newState = {
        fontSizeBox: false,
        fontSpaceBox: false,
        boxHeightBox: false,
        boxWidthBox: false,
        fontFamily: false,
        color: false,
      };
      newState[boxName] = !prevState[boxName];
      return newState;
    });
  };

  const [textStyle, setTextStyle] = useState({
    boldBox: false,
    italicBox: false,
    // color: false,
  });

  const [prevTextStyle, setPrevTextStyle] = useState(textStyle);

  const handleDragToggle = () => {
    setEnableDraggingText((prev) => {
      const newEnableDraggingText = !prev;
      dispatch(handleDragToggleButton(newEnableDraggingText));
      return newEnableDraggingText;
    });
  };

  const handleColorChange = useCallback(
    debounce((color) => {
      console.log(color);
      dispatch(
        updateCoordinate({
          id: currVariable?.id || currVariable?.variable,
          newValue: {
            color: color,
          },
        })
      );
      setTextColor(color);
    }, 300), // Adjust the debounce delay as needed
    [dispatch, currVariable?.id, currVariable?.variable]
  );

  useEffect(() => {
    setEnableDraggingText(dragToggleButton);
  }, [dragToggleButton]);

  useEffect(() => {
    // Check if textStyle has actually changed before updating the coordinates
    if (
      textStyle.boldBox !== prevTextStyle.boldBox ||
      textStyle.italicBox !== prevTextStyle.italicBox
    ) {
      dispatch(
        updateCoordinate({
          id: currVariable?.id || currVariable?.variable,
          newValue: {
            boldVal: textStyle?.boldBox,
            italicVal: textStyle?.italicBox,
          },
        })
      );
      // Update the previous textStyle state
      setPrevTextStyle(textStyle);
    }
  }, [
    textStyle,
    prevTextStyle,
    dispatch,
    currVariable?.id || currVariable?.variable,
  ]);

  useEffect(() => {
    setTextStyle((prev) => ({
      ...prev,
      boldBox: coordinate.boldVal,
      italicBox: coordinate.italicVal,
    }));
  }, []);

  const findRemovedCoord = (id) => {
    const removedCoord = coordinates.find((item) => item.id === id);
    if (removedCoord) {
      dispatch(modifiedCoordinateFunc({ ...removedCoord, action: "removed" }));
    }
  };
  const handleDeleteVariable = (id) => {
    dispatch(deleteCoordinate(id));
    findRemovedCoord(id);
  };

  return (
    <div
      style={{
        position: "absolute",
        left: `${position.prex}px`,
        top: `${position.prey - 38}px`,
        zIndex: 4,
        // background: `${textStyle.color ? "white" : "transparent"}`,
      }}
    >
      <div style={{ position: "absolute", top: "-40px" }}>
        {showHideBox.fontSizeBox && (
          <FontSizeHover settedFontSize={settedFontSize} />
        )}
        {showHideBox.fontSpaceBox && <FontSpacingHover />}
        {showHideBox.boxHeightBox && (
          <BoxHeight settedBoxHeight={settedBoxHeight} />
        )}
        {showHideBox.boxWidthBox && (
          <BoxWidth settedBoxWidth={settedBoxWidth} />
        )}
        {showHideBox.fontFamily && <FontFamilyBox coordinate={coordinate} />}
        {showHideBox.color && (
          <MuiColorInput
            format='rgb'
            style={{
              position: "relative",
              left: "195px",
              top: "-16px",
              // height: "35px",
              width: "180px",
              background: "white",
              borderRadius: "5px",
              width: "52px",
            }}
            value={textColor || coordinate?.color || "#000000"}
            onChange={handleColorChange}
          />
        )}
      </div>
      <div
        style={{
          display: "flex",
          border: "1px solid #1976d2",
          background: "#fff",
          borderRadius: "5px",
          height: "38px",
          boxShadow: "0 0 10px 1px #1976d2",
          alignItems: "center",
        }}
      >
        {/* Drag Box */}
        <Tooltip title={`Toggle Drag`} placement='bottom'>
          <PanToolIcon
            onClick={() => setSelectedBoxId(null)}
            // onClick={() => handleDragToggle()}

            sx={{
              borderRadius: enableDraggingText ? "5px" : "5px",
              color: "#1976d2",
              // color: enableDraggingText ? "#fff" : "#1976d2",
              padding: "7px",
              background: "white",
              // fontSize:'35px !important',
              fill: "currentcolor",
              // fontSize: "2rem !important",
            }}
            // fontSize="large"
            // className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root"
          />
        </Tooltip>
        <div
          style={{ width: "1px", height: "100%", background: "#1976d2" }}
        ></div>
        {/* Font Size */}
        <Tooltip title={`Font Size`} placement='bottom'>
          <TextFieldsIcon
            onClick={() => toggleBox("fontSizeBox")}
            sx={{
              borderRadius: showHideBox?.fontSizeBox ? "5px" : "5px",
              color: showHideBox?.fontSizeBox ? "#fff" : "#1976d2",
              padding: "7px",
              background: showHideBox?.fontSizeBox ? "#1976d2" : "white",
              // fontSize: "2rem !important",
            }}
            // fontSize="large"
          />
        </Tooltip>
        <div
          style={{ width: "1px", height: "100%", background: "#1976d2" }}
        ></div>

        {/* *********Font/Letter Spacing********* */}
        {/* <Tooltip title={`Letter Spacing`} placement="bottom">
          <WidthNormalIcon
            onClick={() => toggleBox("fontSpaceBox")}
            style={{
              borderRadius: showHideBox?.fontSpaceBox ? "5px" : "5px",
              color: showHideBox?.fontSpaceBox ? "#fff" : "#1976d2",
              padding: "7px",
              background: showHideBox?.fontSpaceBox ? "#1976d2" : "white",
            }}
          />
        </Tooltip>
        <div
          style={{ width: "1px", height: "100%", background: "#1976d2" }}
        ></div> */}

        {/* *********Box Height********* */}
        {/* <Tooltip title={`Box Height`} placement="bottom">
          <HeightIcon
            onClick={() => toggleBox("boxHeightBox")}
            style={{
              borderRadius: showHideBox?.boxHeightBox ? "5px" : "5px",
              color: showHideBox?.boxHeightBox ? "#fff" : "#1976d2",
              padding: "7px",
              background: showHideBox?.boxHeightBox ? "#1976d2" : "white",
            }}
          />
        </Tooltip>
        <div
          style={{ width: "1px", height: "100%", background: "#1976d2" }}
        ></div> */}

        {/* *********Box Width********* */}
        {/* <Tooltip title={`Box Width`} placement="bottom">
          <MultipleStopIcon
            onClick={() => toggleBox("boxWidthBox")}
            style={{
              borderRadius: showHideBox?.boxWidthBox ? "5px" : "5px",
              color: showHideBox?.boxWidthBox ? "#fff" : "#1976d2",
              padding: "7px",
              background: showHideBox?.boxWidthBox ? "#1976d2" : "white",
            }}
          />
        </Tooltip>
        <div
          style={{ width: "1px", height: "100%", background: "#1976d2" }}
        ></div> */}

        {/* *********Font Family********* */}
        <Tooltip title={`Font Family`} placement='bottom'>
          <FontDownloadIcon
            onClick={() => toggleBox("fontFamily")}
            sx={{
              borderRadius: showHideBox?.fontFamily ? "5px" : "5px",
              color: showHideBox?.fontFamily ? "#fff" : "#1976d2",
              padding: "7px",
              background: showHideBox?.fontFamily ? "#1976d2" : "white",
              // fontSize: "2rem !important",
            }}
            // fontSize="large"
          />
        </Tooltip>
        <div
          style={{ width: "1px", height: "100%", background: "#1976d2" }}
        ></div>

        {/* *********Bold Box********* */}
        <Tooltip title={`Bold`} placement='bottom'>
          <FormatBoldIcon
            onClick={() =>
              // setTextStyle((perv) => ({ ...perv, boldBox: !coordinate.boldVal }))
              setTextStyle((prev) => ({ ...prev, boldBox: !prev.boldBox }))
            }
            sx={{
              borderRadius: coordinate?.boldVal ? "5px" : "5px",
              color: coordinate?.boldVal ? "#fff" : "#1976d2",
              // borderRadius: textStyle?.boldBox ? "5px" : "5px",
              // color: textStyle?.boldBox ? "#fff" : "#1976d2",
              padding: "7px",
              background: coordinate?.boldVal ? "#1976d2" : "white",
              // background: textStyle?.boldBox ? "#1976d2" : "white",
              // fontSize: "2rem !important",
            }}
            // fontSize="large"
          />
        </Tooltip>

        <div
          style={{ width: "1px", height: "100%", background: "#1976d2" }}
        ></div>

        {/* *********Italic Box********* */}
        <Tooltip title={`Italic`} placement='bottom'>
          <FormatItalicIcon
            onClick={() =>
              // setTextStyle((perv) => ({ ...perv, italicBox: !coordinate?.italicVal }))
              setTextStyle((prev) => ({ ...prev, italicBox: !prev.italicBox }))
            }
            sx={{
              borderRadius: coordinate?.italicVal ? "5px" : "5px",
              color: coordinate?.italicVal ? "#fff" : "#1976d2",
              // borderRadius: textStyle?.italicBox ? "5px" : "5px",
              // color: textStyle?.italicBox ? "#fff" : "#1976d2",
              padding: "7px",
              background: coordinate?.italicVal ? "#1976d2" : "white",
              // fontSize: "2rem !important",
            }}
            // fontSize="large"
          />
        </Tooltip>
        <div
          style={{ width: "1px", height: "100%", background: "#1976d2" }}
        ></div>

        {/* *********Color Box********* */}
        <Tooltip title={`Text Color`} placement='bottom'>
          <ColorLensIcon
            onClick={() => toggleBox("color")}
            sx={{
              borderRadius: coordinate?.color ? "5px" : "5px",
              color: "#1976d2",
              padding: "7px",
              background: "white",
              // fontSize: "2rem !important",
            }}
            // fontSize="large"
          />
        </Tooltip>
        <div
          style={{ width: "1px", height: "100%", background: "#1976d2" }}
        ></div>

        {/* *********Delete Box********* */}
        <Tooltip title={`Delete`} placement='bottom'>
          <DeleteIcon
            onClick={() =>
              handleDeleteVariable(coordinate?.id || coordinate?.variable)
            }
            sx={{
              borderRadius: coordinate?.color ? "5px" : "5px",
              color: "#1976d2",
              padding: "7px",
              background: "white",
              // fontSize: "2rem !important",
            }}
            // fontSize="large"
          />
        </Tooltip>
      </div>
    </div>
  );
}

export default ToolBarText;
